import Vue from 'vue';
import constants from '@/constants/Status.constants';
import dateService from '@/utils/dateService';

Vue.filter('formatDate', value => dateService.getDate(value));

Vue.filter('formatFullDate', value => dateService.getDate(value, 'DD/MM/YYYY - HH:mm'));

Vue.filter('formatCommentDate', value => dateService.getDate(value, 'dddd D, MMMM - HH:mm a'));

Vue.filter('formatHour', value => dateService.getDate(value, 'HH:mm'));

Vue.filter('truncateDescription', (text) => {
  const longestLength = 200;
  if (text.length > longestLength) {
    return `${text.slice(0, longestLength)}...`;
  }
  return text;
});

Vue.filter('formatAction', (value) => {
  const out = value === undefined ? null : constants.ACTIONS[value].description;
  return out;
});

Vue.filter('formatStatus', (value) => {
  const out = value === undefined ? null : constants.STATUSES[value].description;
  return out;
});

Vue.filter('formatStatusEcommerce', (value) => {
  const out = value === undefined ? null : constants.STATUSES_ECOMMERCE[value].description;
  return out;
});

Vue.filter('formatOperator', (value) => {
  const val = (value.length === 2) ? `${value[0]} (Ida) ${value[1]} (Vuelta)` : `${value[0]}`;
  return val;
});

Vue.filter('stripHTML', (value) => {
  const div = document.createElement('div');
  div.innerHTML = value;
  const text = div.textContent || div.innerText || '';
  return text;
});



// WEBPACK FOOTER //
// ./src/filters/filters.js